import { AlertType } from '@kcftech/prometheustypescriptapiclient';
import type { KCFTheme } from 'styles/themes/KCFTheme';

// Severity levels as const values instead of enum
export const AlertSeverity = {
    WARNING: 0,
    ALARM: 1,
    CRITICAL: 2,
} as const;

// Type for severity values
export type AlertSeverityType = typeof AlertSeverity[keyof typeof AlertSeverity];

// Default severity for unknown alert types
export const DEFAULT_SEVERITY = AlertSeverity.WARNING;

// Map alert types to severity levels
export const ALERT_TYPE_SEVERITY_MAP: Record<AlertType, AlertSeverityType> = {
    [AlertType.IndicatorCriticalHighAlarm]: AlertSeverity.CRITICAL,
    [AlertType.IndicatorCriticalLowAlarm]: AlertSeverity.CRITICAL,
    [AlertType.IndicatorHighAlarm]: AlertSeverity.ALARM,
    [AlertType.IndicatorLowAlarm]: AlertSeverity.ALARM,
    [AlertType.IndicatorHighWarning]: AlertSeverity.WARNING,
    [AlertType.IndicatorLowWarning]: AlertSeverity.WARNING,
};

// Helper function to get severity with fallback
export function getAlertSeverity(alertType: AlertType): AlertSeverityType {
    return ALERT_TYPE_SEVERITY_MAP[alertType];
}

// Helper function to convert local severity number to standard AlertSeverity enum
export function getStandardizedSeverity(
    severityNumber: AlertSeverityType
): AlertSeverityType {
    switch (severityNumber) {
        case AlertSeverity.CRITICAL: {
            return AlertSeverity.CRITICAL;
        }
        case AlertSeverity.ALARM: {
            return AlertSeverity.ALARM;
        }
        default: {
            return AlertSeverity.WARNING;
        }
    }
}

// Color mapping for each severity level (maps to theme property keys)
export const SEVERITY_COLOR_MAP: Record<AlertSeverityType, keyof KCFTheme> = {
    [AlertSeverity.CRITICAL]: 'criticalSeverity',
    [AlertSeverity.ALARM]: 'alarmSeverity',
    [AlertSeverity.WARNING]: 'warningSeverity',
};

// Labels for each severity level
export const SEVERITY_LABEL_MAP: Record<AlertSeverityType, string> = {
    [AlertSeverity.CRITICAL]: 'CRITICAL ALARM',
    [AlertSeverity.ALARM]: 'ALARM',
    [AlertSeverity.WARNING]: 'WARNING',
};
